import React, { Component, Fragment } from "react";
import { Container, Row, Card, UncontrolledButtonDropdown, DropdownMenu, DropdownToggle, Label, DropdownItem, Button } from "reactstrap";
import { Switch, Select } from "antd";

import "./index.css";
// import { getPolygons } from "../../service/homeService";
import { GoogleMap } from "../../common";
import { populationPolygons, populationDensityPolygons } from "./constant";
import data from "./data.json";
import MultiSelect from "./MultiSelect";
import { getDataFile, getPinsDataFile } from "./data/dataService";
import { petrolPump } from "../../assets/images";
import { icon } from "@fortawesome/fontawesome-svg-core";
class MapHandler extends Component {
	state = {
		polygons: {},
		center: {},
		updateTime: Date.now(),
		markers: {},
		selectCategory: "",
		isHeatmapOn: false,
		isClusterOn: true,
		heatmapData: {},
		pins: {},
	};

	componentDidMount() {
		this.setData();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.selectedDistrict !== this.props.selectedDistrict) return this.setData();
	}

	setData = async () => {
		let { selectedDistrict } = this.props;
		if (!selectedDistrict) return;
		try {
			// let [polygonData] = await Promise.all([getPolygons({ district_name: selectedDistrict })]);
			let polygonInfo = getDataFile({ district: selectedDistrict });
			let { polygons: dPolygons, center, maxPopulation, minPopulation } = polygonInfo;
			let { polygons, labels } = populationPolygons(dPolygons, maxPopulation, minPopulation);

			this.setState({
				center,
				polygons,
				markers: {},
				updateTime: Date.now(),
				selectCategory: "",
				isHeatmapOn: false,
				isClusterOn: true,
				heatmapData: {},
				pins: {},
			});
		} catch (error) {
			console.error(error);
		}
	};

	onChangePopulationSwitch = (checked) => {
		let { selectedDistrict } = this.props;
		if (checked) {
			let polygonInfo = getDataFile({ district: selectedDistrict });
			let { density } = polygonInfo;
			let heatmapData = populationDensityPolygons(density);
			this.setState({ heatmapData, isHeatmapOn: checked });
		} else {
			this.setState({ heatmapData: {}, isHeatmapOn: checked });
		}
	};

	onChangeBoundarySwitch = (checked) => {
		this.setState({ isClusterOn: checked });
	};

	handleModal = (selectedMarker = "") => console.log(selectedMarker);

	handleMarker = () => {
		let { selectCategory } = this.state;
		let { selectedDistrict } = this.props;
		let pins = {};
		if (selectCategory) {
			let markerInfo = getPinsDataFile({ district: selectedDistrict });
			markerInfo.forEach(({ latitude: lat, longtitude: lng }, id) => {
				pins[`markers${id}`] = {
					position: { lat: Number(lat), lng: Number(lng) },

					data: {
						id,
					},
					showInfo: true,
					icon: petrolPump,
				};
			});
		}
		this.setState({ pins });
	};

	render() {
		let { polygons, center, markers, selectCategory, isHeatmapOn, isClusterOn, heatmapData, pins } = this.state;
		let { selectedDistrict } = this.props;

		return (
			<Container fluid>
				<div className="mt-2">
					<Row className="mt-0">
						{polygons && !_.isEmpty(polygons) && (
							<>
								<Card style={{ border: "0px", boxShadow: "0px 0px 5px 5px #F0F0F0F0" }}>
									<div className="d-flex flex-direction-row my-1">
										<div className="d-flex align-items-center">
											<Switch value={isHeatmapOn} onChange={this.onChangePopulationSwitch} />{" "}
											<sapn className="mx-2">Population Heatmap</sapn>
										</div>
										<div className="d-flex align-items-center">
											<Switch value={isClusterOn} onChange={this.onChangeBoundarySwitch} />{" "}
											<sapn className="mx-2">Clusters</sapn>
										</div>
										<div key="category_dropdown" className="mx-2">
											{/* <Select
												defaultValue="select_category"
												style={{
													width: 150,
												}}
												onChange={(val) => {
													this.setState({ selectCategory: val === "select_category" ? "" : val });
												}}
												options={[
													{
														value: "select_category",
														label: "Select Category",
													},
													{
														value: "banks",
														label: "Banks",
													},
													{
														value: "petrol_pumps",
														label: "Petrol Pumps",
													},
												]}
											/> */}
											<UncontrolledButtonDropdown
												trigger="focus"
												direction="down"
												disabled={["riyadh"].includes(selectedDistrict)}
											>
												<DropdownToggle caret color="primary">
													{selectCategory === "" ? "Select Category" : selectCategory}
												</DropdownToggle>
												<DropdownMenu style={{ overflowY: "auto", maxHeight: "120px" }}>
													<div className="ml-2 pl-3">
														{[
															{
																value: "select_category",
																label: "Select Category",
															},
															{
																value: "banks",
																label: "Banks",
															},
															{
																value: "petrol_pumps",
																label: "Petrol Pumps",
															},
														].map(({ label, value }, ind) => {
															return (
																<DropdownItem
																	onClick={(e) => {
																		let val = label;
																		this.setState(
																			{
																				selectCategory: val === "Select Category" ? "" : val,
																			},
																			this.handleMarker
																		);
																	}}
																>
																	<span style={{ fontSize: "14px" }}> {_.startCase(label)}</span>
																</DropdownItem>
															);
														})}
													</div>
												</DropdownMenu>
											</UncontrolledButtonDropdown>
										</div>
										{/* {selectCategory && <MultiSelect selected={selectCategory} />} */}
										<div className="d-flex align-items-center ms-auto">
											<Button color="primary">Download Data</Button>
										</div>
									</div>
								</Card>
								<div className="mapShadow mt-1" style={{ minHeight: "400px", height: "550px" }}>
									<GoogleMap
										polygons={polygons}
										center={center}
										markers={{ ...markers, ...pins }}
										handleMarkerClick={(id) => {
											this.handleModal(id);
										}}
										defaultZoom={12}
										heightFactor={0.64}
										buildHeatMap={isHeatmapOn}
										showPolygonBoundary={isClusterOn}
										heatmapData={heatmapData}
									/>
								</div>
							</>
						)}
					</Row>
				</div>
			</Container>
		);
	}
}

export default MapHandler;
